import React, { ReactNode } from 'react';
import { DateTime } from 'luxon';

type IconAndLogProps = {
  icon: ReactNode;
  log: string;
  type: string;
  dayText?: string;
  timestamp?: string;
  timezone?: string;
};

const IconAndLog: React.FC<IconAndLogProps> = ({
  icon,
  log,
  type,
  dayText,
  timestamp,
  timezone,
}) => {
  const updatedHtml = log?.replace(/href="([^"]+)"/, (match, url) => {
    try {
      const parsedUrl = new URL(url);

      const emailMatch = parsedUrl?.pathname?.match(/\/email\/(\d+)/);
      if (!emailMatch) return match;

      const emailId = emailMatch[1];

      parsedUrl.pathname = parsedUrl?.pathname?.replace(
        /\/email\/\d+/,
        '/email',
      );
      parsedUrl.searchParams.set('emailId', emailId);

      return `href="${parsedUrl.toString()}"`;
    } catch {
      return match;
    }
  });

  const formattedTime = timestamp
    ? DateTime.fromISO(timestamp).setZone(timezone).toFormat('h:mm a')
    : null;

  return (
    <div className="icon-log-container d-flex">
      <div className="icon-container-wrapper">
        <div className={`icon-container icon-${type}`}>{icon}</div>{' '}
      </div>
      <div className="d-flex justify-content-between w-100 gap-4 icon-log-single-field">
        <div
          className="activity-html-content"
          dangerouslySetInnerHTML={{ __html: updatedHtml }}
        />
        {dayText && (
          <div className="activity-day-text">
            {dayText} · {formattedTime}
          </div>
        )}
      </div>
    </div>
  );
};

export default IconAndLog;
